import { usePosterContext } from "../../../context/poster-context";
import {
  ColorInput,
  MainInfoContentWrapper,
} from "../info/main-info/styles/main-info.style";
import { EditTabHeaderItem, EditWrapper } from "../styles";

const EditBackgroundColor = () => {
  const { background, setBackground } = usePosterContext();

  const normalizeColor = (color: string | undefined): string => {
    const trimmed = color?.trim().toUpperCase() || "#FFFFFF";
    if (trimmed.length === 4 && trimmed.startsWith("#")) {
      // #FFF 형식을 #FFFFFF로 변환
      return `#${trimmed[1]}${trimmed[1]}${trimmed[2]}${trimmed[2]}${trimmed[3]}${trimmed[3]}`;
    }
    return trimmed;
  };
  return (
    <EditWrapper>
      <MainInfoContentWrapper>
        <div className="label">배경 색상 : </div>
        <ColorInput
          style={{
            marginLeft: "10px",
          }}
          type="color"
          value={normalizeColor(background)}
          onChange={(e) => {
            setBackground(e.target.value.toUpperCase());
          }}
        />
      </MainInfoContentWrapper>
    </EditWrapper>
  );
};

export default EditBackgroundColor;
